import { render, staticRenderFns } from "./PressJoinMaterialSettings.vue?vue&type=template&id=25dac936"
import script from "./PressJoinMaterialSettings.vue?vue&type=script&lang=ts"
export * from "./PressJoinMaterialSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports